import Parse from "parse";
import {Languages} from "../utilities/Constants";

class Post extends Parse.Object {

    constructor() {
        super('Post');
    }

    getTitle() {
        return this.get('title');
    }

    setTitle(title) {
        this.set('title', title)
    }

    getTagline() {
        return this.get('tagline');
    }

    setTagline(tagline) {
        this.set('tagline', tagline)
    }

    getImageUrl() {
        return this.get("coverMedia").url()
    }

    setCoverPhotoFile(file) {
        this.set("coverMedia", file);
    }

    getVideoURL() {
        return this.get('videoUrl');
    }

    setVideoURL(videoURL) {
        this.set('videoUrl', videoURL)
    }

    getLanguage() {
        const languageCode = this.get('languageCodeString');
        return Languages.filter(option => option.key === languageCode)[0]
    }

    setLanguageCode(code) {
        this.set('languageCodeString', code);
    }

    getCategoryTitle() {
        return this.get("category").getTitle();
    }

    getCategory() {
        return this.get("category");
    }

    setCategory(category) {
        this.set('category', category);
        this.set('categoryId', category.id);
    }

    setEnabled(enabled) {
        this.set('enabled', enabled);
    }

    static getQuery() {
        const parseQuery = new Parse.Query(Post);
        parseQuery.equalTo("enabled", true);
        parseQuery.descending("createdAt");
        parseQuery.include("category");
        return parseQuery;
    }

    static getFilteredQuery(languageCode, categoryId, skip, limit) {
        const parseQuery = new Parse.Query(Post);
        parseQuery.equalTo("enabled", true);
        parseQuery.include("category");
        parseQuery.skip(skip);
        parseQuery.limit(limit);
        parseQuery.descending("createdAt")
        parseQuery.withCount()
        if (languageCode != null) {
            parseQuery.equalTo("languageCodeString", languageCode);
        }
        if (categoryId != null) {
            parseQuery.equalTo("categoryId", categoryId);
        }
        return parseQuery;
    }
}

export default Post;